/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../components/style.css"
import QRCode from 'qrcode.react';
import { FaQrcode } from "react-icons/fa";
import jwt from "jsonwebtoken";
import { getlocalStorage } from '../function/functionALL';
import Swal from 'sweetalert2';


require("moment/locale/th");

const ModalQRCodeUser = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { DataToken_ } = getlocalStorage();

    // let result = null;
    const [QR, setQR] = useState("")


    useEffect(() => {
        const fetchQRData = async () => {
            try {

                // const getQR = DataLogin.af_id.toString();
                const getQR = DataToken_.af_id != null ? DataToken_.af_id.toString() : DataToken_.person_id.toString();

                setQR(getQR);

            } catch (error) {

                console.error(error);
                Swal.fire({
                    icon: "error",
                   
                });
            }
        };

        fetchQRData();
    }, []);

    return (
        <>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 mt-3 mt-md-0 justify-contents-end ">
                <button type="button" className="col-12 col-sm-12 col-md-12 btn btn-primary px-3" style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={handleShow} >
                    <div style={{ fontSize: "16px" }}><FaQrcode /> QR Code ของฉัน<i className='fas fa-camera'></i></div>
                </button>
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                centered
                keyboard={true}
            >
                <Modal.Body>
                    <div className="rounded">
                        <div className="px-3 pt-2">
                            <div className="col-sm-12 col-xs-12">
                                <div className="card-body rounded">
                                    <div className="row d-flex p-2 mb-2">
                                        <div className="col-3 col-xs-12 card-title text-center fs-5 w-100 fs-3" style={{ color: "#000000" }}>
                                            <div className="fw-bold" style={{ fontSize: "25px" }}>QR Code ของฉัน</div>
                                        </div>
                                        <hr></hr>
                                    </div>

                                    <form className="row ">
                                        <div className="col-md-12 text-center" style={{ backgroundColor: "#FFFFFF" }} >
                                            {QR && <QRCode value={QR} size={220} />}
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="col-md-12 col-12 gap-3 d-flex justify-content-center">
                        <Button variant="primary" style={{ backgroundColor: "rgb(2, 117, 216,0.80)", border: "none" }} onClick={handleClose}>
                            ตกลง
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalQRCodeUser